import { Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { financialPeriodsQueryKey } from "../../financials";

export function useAdminUpdateProfitability(accountId: SuretyAccountId, isFye?: boolean) {
	const { patch } = useRequest();
	const queryClient = useQueryClient();

	const endpoint = isFye ? "profitability-fye" : "profitability-ytd";

	const mutation = useMutation({
		mutationFn: async ({
			data,
		}: {
			data: Dtos.Admin.FinancialPeriod.Update.Profitability.Request;
			onSuccess?: () => void;
			onError?: () => void;
		}) =>
			patch<Dtos.Admin.FinancialPeriod.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/financial-periods/${endpoint}`,
				data,
			),
		onSuccess: (_, { onSuccess }) => {
			queryClient.invalidateQueries({
				queryKey: financialPeriodsQueryKey(accountId),
			});

			onSuccess?.();
		},
		onError: (_, { onError }) => {
			onError?.();
		},
	});

	return {
		updateProfitability: mutation.mutate,
		updateProfitabilityLoading: mutation.isPending,
		updateProfitabilityError: mutation.error,
		dismissUpdateProfitabilityError: () => {
			mutation.reset();
		},
	};
}
